import { render, staticRenderFns } from "./EditTripInclusions.vue?vue&type=template&id=3363a2b2"
import script from "./EditTripInclusions.vue?vue&type=script&lang=js"
export * from "./EditTripInclusions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports